import type { Entry } from 'contentful';

import type { CompositionItem, Config, Model } from '../components/resolver/config';

export type MapEntry = (entry: Entry) => CompositionItem | null;
export type Transform = (entry: Entry, map: MapEntry) => Model['props'] | null;
export type Transforms = Partial<Record<string, Transform>>;

export function mapEntry(entry: Entry, transforms: Transforms): CompositionItem | null {
    const contentType = entry.sys.contentType.sys.id;
    const transform = transforms[contentType];
    if (!transform) return entry;

    const props = transform(entry, child => mapEntry(child, transforms));
    return props === null ? null : { contentType: contentType as keyof Config, props };
}

export function mapEntries(entries: readonly Entry[] | undefined, transforms: Transforms): CompositionItem[] {
    return (entries ?? []).map(entry => mapEntry(entry, transforms)).filter(entry => entry !== null);
}
